import { useState, useEffect } from 'react';

/* To know if the component has hydrated on the browser vs rendered on the server */
const useMounted = () => {
	const [isMounted, setMounted] = useState(false);
	useEffect(() => {
		setMounted(true);
	}, []);
	return isMounted;
};

export default useMounted;
